import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `SignMessageControllerStateProvider` not mounted on RN.
export default function useSignMessageControllerState(): any {
  const { state } = useController('SignMessageController' as any)
  return state as any
}
